import { transformCurrencyAmountDto } from '@marketplace-web/currency/currency-data'

import {
  BundleItemPhotoDto,
  BundleItemPhotoModel,
  BundleTransactionDto,
  BundleTransactionItemDto,
  BundleTransactionItemModel,
  BundleTransactionModel,
  CreateBundleInquiryResp,
} from '../types/bundle-transaction'
import { findThumbnail } from '../utils/photo'

enum ItemThumbnailSize {
  Medium = 'thumb150x210',
}

const getItemThumbnail = (
  photos: Array<{
    is_main: boolean
    thumbnails: Array<{ type: ItemThumbnailSize | string; url: string }>
  }>,
  size = ItemThumbnailSize.Medium,
) => {
  const photo = photos?.find(({ is_main }) => is_main)

  return findThumbnail(photo, size)
}

const transformBundleItemPhotoDto = (photo: BundleItemPhotoDto): BundleItemPhotoModel => ({
  url: photo.url,
  thumbnails: photo.thumbnails,
  isMain: photo.is_main,
  imageNo: photo.image_no,
})

const transformBundleItemPhotoDtos = (
  photos: Array<BundleItemPhotoDto>,
): Array<BundleItemPhotoModel> => photos.map(transformBundleItemPhotoDto)

const transformTransactionItemDto = (
  item: BundleTransactionItemDto,
): BundleTransactionItemModel => ({
  id: item.id,
  title: item.title,
  size: item.size_title || '',
  status: item.status,
  price: transformCurrencyAmountDto(item.price),
  thumbnailUrl: getItemThumbnail(item.photos),
  url: item.url,
  photos: transformBundleItemPhotoDtos(item.photos),
})

export const transformBundleTransactionItemDtos = (
  items: Array<BundleTransactionItemDto>,
): Array<BundleTransactionItemModel> => items.map(transformTransactionItemDto)

export const transformBundleInquiry = (
  response: CreateBundleInquiryResp,
): BundleTransactionModel => ({
  id: Number(response.transaction_id),
  conversationId: response.conversation_id,
})

export const transformBundleTransaction = ({
  id,
  user_msg_thread_id,
}: BundleTransactionDto): BundleTransactionModel => ({
  id,
  conversationId: user_msg_thread_id.toString(),
})
